function getBootstrapPayload() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.__SUARTE_SSR__?.profile ?? null;
}

export function getSsrProfileBootstrap(profileUsername) {
  const payload = getBootstrapPayload();
  if (!payload) {
    return null;
  }

  if (payload.username !== profileUsername) {
    return null;
  }

  return payload;
}
